
function Footer() {
    return (
        <footer style={{ textAlign: 'center', maxWidth: '100%', padding: '20px', backgroundColor: '#f1f1f1' }}>
            <p>
                Të citohet: Islami, B., Ibrahimi, K., Ibrahimi, H., Grapci-Kotori, L., Bilalli, A., Musliu, M., Gashi., A & Geci, D. (2025). Fauna of Kosovo. Version  2.
            </p>
            <hr style={{ margin: '16px auto', maxWidth: '600px', border: 'none', borderTop: '1px solid #ccc' }} />
            <p style={{ fontSize: '0.8rem', color: '#666', maxWidth: '95%', margin: '0 auto', lineHeight: '1.4' }}>
                Të gjitha fotografitë publikuara në këtë faqe janë të mbrojtura nën licencën Creative Commons Attribution–NonCommercial 4.0 International (CC BY-NC 4.0), përveç rasteve kur me leje te veçantë lejohen nga autorët. Kjo licencë lejon përdorimin, shpërndarjen dhe përshtatjen e materialit vetëm për qëllime jo-komerciale dhe me atribim të duhur ndaj autorit origjinal. Çdo përdorim komercial i materialeve pa leje paraprake me shkrim nga autori është i ndaluar dhe mund të përbëjë shkelje të të drejtës së autorit.
            </p>
        </footer>
    );
}

export default Footer;

